import React, { useState } from 'react'
import { Modal, Box, Typography, Tabs, Tab, Button, Menu as MuiMenu, MenuItem } from '@mui/material'
import { motion } from 'framer-motion'
import EdTextfield from '@/components/forms/EdTextfield'
import { RiArrowDownSLine } from "react-icons/ri"
import UploadMaterialModal from './UploadMaterialModal'
import MaterialViewerModal from './MaterialViewerModal'

interface AssociaMaterialeModalProps {
  isOpen: boolean
  onClose: () => void
}

interface MaterialeItem {
  id: number
  codice: string
  nomeFile: string
  tempoStudio: string
  associazioneCorso: string
  domandeAssociate: number
}

const AssociaMaterialeModal: React.FC<AssociaMaterialeModalProps> = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState(0)
  const [selectedItems, setSelectedItems] = useState<number[]>([])
  const [uploadButtonAnchorEl, setUploadButtonAnchorEl] = useState<null | HTMLElement>(null)
  const [activeUploadModal, setActiveUploadModal] = useState<'video' | 'scorm' | 'pdf' | null>(null)
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState<null | HTMLElement>(null)
  const [selectedMaterialId, setSelectedMaterialId] = useState<number | null>(null)
  const [showViewerModal, setShowViewerModal] = useState(false)
  const [selectedMaterialForView, setSelectedMaterialForView] = useState<MaterialeItem | null>(null)


  const materialTypes = [
    { id: 'scorm', label: 'SCORM', count: 20 },
    { id: 'video', label: 'VIDEO', count: 5 },
    { id: 'pdf', label: 'PDF', count: 5 }
  ]

  const uploadOptions = [
    { id: 'video', label: 'Video' },
    { id: 'scorm', label: 'SCORM' },
    { id: 'pdf', label: 'PDF' }
  ]

  const mockMaterials: MaterialeItem[] = [
    {
      id: 1,
      codice: 'FORM_LAV',
      nomeFile: 'Verifica impianto elettrico secondo la norma CE 32948.234909234',
      tempoStudio: '24 min',
      associazioneCorso: 'Nome corso',
      domandeAssociate: 8
    },
    {
      id: 2,
      codice: 'FORM_LAV',
      nomeFile: 'Verifica impianto elettrico secondo la norma CE 32948.234909234',
      tempoStudio: '24 min',
      associazioneCorso: 'Nome corso, nome corso +2',
      domandeAssociate: 8
    },
    {
      id: 3,
      codice: 'FORM_LAV',
      nomeFile: 'Verifica impianto elettrico secondo la norma CE 32948.234909234',
      tempoStudio: '24 min',
      associazioneCorso: '',
      domandeAssociate: 8
    },
    {
      id: 4,
      codice: 'FORM_LAV',
      nomeFile: 'Verifica impianto elettrico secondo la norma CE 32948.234909234',
      tempoStudio: '24 min',
      associazioneCorso: 'Nome corso',
      domandeAssociate: 8
    },
    {
      id: 5,
      codice: 'FORM_LAV',
      nomeFile: 'Verifica impianto elettrico secondo la norma CE 32948.234909234',
      tempoStudio: '24 min',
      associazioneCorso: '',
      domandeAssociate: 8
    }
  ]

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
  }

  const handleSelectItem = (itemId: number) => {
    setSelectedItems(prev => 
      prev.includes(itemId) 
        ? prev.filter(id => id !== itemId)
        : [...prev, itemId]
    )
  }

  const handleSelectAll = () => {
    if (selectedItems.length === mockMaterials.length) {
      setSelectedItems([])
    } else {
      setSelectedItems(mockMaterials.map(item => item.id))
    }
  }

  const handleClose = () => {
    setSelectedItems([])
    setActiveTab(0) // Reset alla prima tab
    onClose()
  }

  const handleUploadButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    setUploadButtonAnchorEl(event.currentTarget)
  }

  const handleUploadButtonClose = () => {
    setUploadButtonAnchorEl(null)
  }

  const handleUploadOptionClick = (optionId: 'video' | 'scorm' | 'pdf') => {
    setActiveUploadModal(optionId)
    handleUploadButtonClose()
  }

  const closeUploadModal = () => {
    setActiveUploadModal(null)
  }

  const handleActionMenuOpen = (event: React.MouseEvent<HTMLElement>, materialId: number) => {
    setActionMenuAnchorEl(event.currentTarget)
    setSelectedMaterialId(materialId)
  }

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null)
    setSelectedMaterialId(null)
  }

  const handleDeleteMaterial = () => {
    if (selectedMaterialId) {
      console.log('Eliminando materiale con ID:', selectedMaterialId)
      // Qui implementeresti la logica per eliminare il materiale
      handleActionMenuClose()
    }
  }

  const handlePlayClick = (material: MaterialeItem) => {
    setSelectedMaterialForView(material)
    setShowViewerModal(true)
  }

  const closeViewerModal = () => {
    setShowViewerModal(false)
    setSelectedMaterialForView(null)
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="associa-materiale-modal-title"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '1200px' },
          height: { xs: '90vh', sm: '80vh' },
          bgcolor: 'background.paper',
          borderRadius: 0,
          boxShadow: 24,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <Box sx={{ px:3, pt:2,  backgroundColor: '#F8F9F9' }}>
          <div className="flex items-center justify-between w-full">
            <Typography id="associa-materiale-modal-title" variant="h6" component="h2" sx={{ color: '#4F4F4F', fontWeight: 'bold' }}>
              Associa materiale didattico
            </Typography>
            <div className="w-[250px] pt-2">
              <EdTextfield 
                id="search-materiale"
                label="Ricerca"
                type="text"
                placeholder="Ricerca"
               
              
              />
            
            </div>
          </div>
        </Box>

        {/* Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3, backgroundColor: '#F8F9F9', pt:2 }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange} 
            aria-label="material tabs"
            variant="fullWidth"
            sx={{
              outline: 'none',
              
              border: 'none',
              '& .MuiTabs-indicator': {
                backgroundColor: '#B80F15',
                height: 3,
              },
              '& .MuiTab-root': {
                color: '#6B7280',
                fontWeight: 500,
                padding: '10px 0px',
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                minHeight: 48,
                '&.Mui-selected': {
                  color: '#B80F15',
                  fontWeight: 600,
                  outline: 'none',
                  boxShadow: 'none',
                  border: 'none',
                },
                '&:hover': {
                  color: '#B80F15',
                  backgroundColor: 'rgba(184, 15, 21, 0.04)',
                },
                '&:active':{
                  border: 'none',
                  outline: 'none',
                  boxShadow: 'none',
                },
                '&:focus':{
                  border: 'none',
                  boxShadow: 'none',
                  outline: 'none',
                }
              },
            }}
          >
            {materialTypes.map((type) => (
              <Tab key={type.id} label={`${type.label} (${type.count})`} />
            ))}
          </Tabs>
        </Box>

        {/* Table Content */}
        <Box sx={{ flex: 1, overflow: 'auto', }}>
          <div className="bg-white">
            {/* Table Header */}
            <div className="flex items-center py-3 border-b border-gray-200 bg-gray-50">
              <div className="w-12 flex justify-center">
                <input
                  type="checkbox"
                  checked={selectedItems.length === mockMaterials.length && mockMaterials.length > 0}
                  onChange={handleSelectAll}
                  className="w-4 h-4 text-[#B80F15] border-gray-300 rounded focus:ring-[#B80F15]"
                />
              </div>
              <div className="flex-1 px-4">
                <span className="text-sm font-medium text-[#4F4F4F] flex items-center gap-2">
                  Codice
                  <i className="ri-filter-line text-gray-400"></i>
                </span>
              </div>
              <div className="flex-1 px-4">
                <span className="text-sm font-medium text-[#4F4F4F] flex items-center gap-2">
                  Nome file
                  <i className="ri-filter-line text-gray-400"></i>
                </span>
              </div>
              <div className="w-32 px-4">
                <span className="text-sm font-medium text-[#4F4F4F] flex items-center gap-2">
                  Tempo di studio
                  <i className="ri-filter-line text-gray-400"></i>
                </span>
              </div>
              <div className="flex-1 px-4">
                <span className="text-sm font-medium text-[#4F4F4F] flex items-center gap-2">
                  Associazione al corso
                  <i className="ri-filter-line text-gray-400"></i>
                </span>
              </div>
              <div className="w-32 px-4">
                <span className="text-sm font-medium text-[#4F4F4F] flex items-center gap-2">
                  Dom. associate
                  <i className="ri-filter-line text-gray-400"></i>
                </span>
              </div>
            </div>

            {/* Table Rows */}
            <div className="space-y-0">
              {mockMaterials.map((material, index) => (
                <motion.div 
                  key={material.id}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2, delay: index * 0.05 }}
                  className={`flex items-center py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors duration-200 ${
                    selectedItems.includes(material.id) 
                      ? 'bg-red-50' 
                      : 'bg-white'
                  }`}
                >
                  <div className="w-12 flex justify-center">
                    <input
                      type="checkbox"
                      checked={selectedItems.includes(material.id)}
                      onChange={() => handleSelectItem(material.id)}
                      className="w-4 h-4 text-[#B80F15] border-gray-300 rounded focus:ring-[#B80F15] cursor-pointer"
                    />
                  </div>
                  <div className="flex-1 px-4 cursor-pointer" onClick={() => handleSelectItem(material.id)}>
                    <span className="text-sm text-[#4F4F4F]">{material.codice}</span>
                  </div>
                  <div className="flex-1 px-4 cursor-pointer" onClick={() => handleSelectItem(material.id)}>
                    <span className="text-sm text-[#B80F15] font-medium">{material.nomeFile}</span>
                  </div>
                  <div className="w-32 px-4 cursor-pointer" onClick={() => handleSelectItem(material.id)}>
                    <span className="text-sm text-[#4F4F4F]">{material.tempoStudio}</span>
                  </div>
                  <div className="flex-1 px-4 cursor-pointer" onClick={() => handleSelectItem(material.id)}>
                    <span className="text-sm text-[#4F4F4F]">{material.associazioneCorso}</span>
                  </div>
                  <div className="w-32 px-4">
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-[#4F4F4F] cursor-pointer" onClick={() => handleSelectItem(material.id)}>{material.domandeAssociate}</span>
                      <i 
                        className="ri-play-circle-line text-gray-400 hover:text-[#B80F15] cursor-pointer transition-colors"
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePlayClick(material);
                        }}
                      ></i>
                      <i 
                        className="ri-more-2-fill text-gray-400 hover:text-gray-600 cursor-pointer transition-colors"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleActionMenuOpen(e, material.id);
                        }}
                      ></i>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </Box>

        {/* Footer with buttons */}
        <Box sx={{ 
          borderTop: 1, 
          borderColor: 'divider', 
          p: 3,
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div className="flex items-center gap-3">
          <Button
            variant="contained"
            disabled={selectedItems.length === 0}
            sx={{
              backgroundColor: selectedItems.length > 0 ? '#B80F15' : '#D1D5DB',
              color: selectedItems.length > 0 ? 'white' : '#9CA3AF',
              textTransform: 'uppercase',
              fontSize: '12px',
              fontWeight: 'bold',
              px: 3,
              py: 1,
              '&:hover': {
                backgroundColor: selectedItems.length > 0 ? '#A00D13' : '#D1D5DB',
              },
              '&:disabled': {
                backgroundColor: '#D1D5DB',
                color: '#9CA3AF',
              },
            }}
          >
            {selectedItems.length === 0 
              ? 'SELEZIONA MATERIALE DA ALLEGARE' 
              : `SELEZIONATI (${selectedItems.length})`
            }
          </Button>
          <Button
              variant="outlined"
              onClick={handleClose}
              sx={{
                backgroundColor: '#E3EBF7',
                color: '#285192',
                textTransform: 'uppercase',
                fontSize: '12px',
                fontWeight: 'medium',
                px: 3,
                py: 1,
               border: 'none'
              }}
            >
              ANNULLA
            </Button>
            </div>
          <div className="flex items-center gap-3">
            <Button
              variant="contained"
              onClick={handleUploadButtonClick}
              endIcon={<RiArrowDownSLine className="text-[12px]"/>}
              sx={{
                backgroundColor: '#E3EBF7',
                color: '#285192',
                textTransform: 'uppercase',
                fontSize: '12px',
                fontWeight: 'medium',
                px: 3,
                py: 1,
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: '#BDBDBD',
                },
                '&:focus': {
                  outline: 'none',
                  boxShadow: 'none',
                },
              }}
            >
              + CARICA NUOVO MATERIALE
            </Button>
            <MuiMenu
              anchorEl={uploadButtonAnchorEl}
              open={Boolean(uploadButtonAnchorEl)}
              onClose={handleUploadButtonClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 180,
                  boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  borderRadius: '8px',
                },
              }}
            >
              {uploadOptions.map((option) => (
                <MenuItem key={option.id} onClick={() => handleUploadOptionClick(option.id as 'video' | 'scorm' | 'pdf')}>
                  {option.label}
                </MenuItem>
              ))}
            </MuiMenu>
          </div>
        </Box>

        {/* Upload Modals */}
        <UploadMaterialModal 
          isOpen={activeUploadModal === 'video'} 
          onClose={closeUploadModal} 
          materialType="video"
        />
        <UploadMaterialModal 
          isOpen={activeUploadModal === 'scorm'} 
          onClose={closeUploadModal} 
          materialType="scorm"
        />
        <UploadMaterialModal 
          isOpen={activeUploadModal === 'pdf'} 
          onClose={closeUploadModal} 
          materialType="pdf"
        />

        {/* Action Menu */}
        <MuiMenu
          anchorEl={actionMenuAnchorEl}
          open={Boolean(actionMenuAnchorEl)}
          onClose={handleActionMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            sx: {
              mt: 1,
              minWidth: 150,
              boxShadow: '1px 1px 15px 0px rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
            },
          }}
        >
          <MenuItem onClick={handleDeleteMaterial} sx={{ color: '#000000' }}>
            Elimina
          </MenuItem>
        </MuiMenu>

        {/* Material Viewer Modal */}
        <MaterialViewerModal 
          isOpen={showViewerModal}
          onClose={closeViewerModal}
          material={selectedMaterialForView}
        />
      </Box>
    </Modal>
  )
}

export default AssociaMaterialeModal
